import { useSelector } from "react-redux";
import { ICommonFieldProps } from "../../../../interfaces";
import { user } from "@lhd/features/users/selector";
import CommonSelector from "@lhd/components/CommonSelector";

const WorkingTypeEditCell = (props: ICommonFieldProps) => {
  const auth = useSelector(user);
  const WORKER = auth?.workingTypeOptions || {};
  const WORKER_TYPE_OPTIONS = Object.keys(WORKER)?.map((i) => ({
    value: i,
    label: WORKER[i],
  }));
  const { defaultValue, onChange } = props;
  return (
    <CommonSelector
      defaultValue={defaultValue}
      options={WORKER_TYPE_OPTIONS}
      height="calc(100% - var(--cell-vertical-spacing))"
      onChange={onChange}
      showSearch
    />
  );
};

export default WorkingTypeEditCell;
